// localStorage que não derruba a central. Dentro de um iframe de outro site (o "Ajuda" dos
// painéis app.*.com.br), o Safari e navegadores com cookies de terceiros bloqueados negam o
// acesso e a simples leitura lança SecurityError. Nesses casos as conversas ficam só na memória
// da aba: o chat funciona, apenas sem guardar o histórico depois de fechar.
// Falta de espaço (QuotaExceededError) continua sendo lançada: armazenamento.ts trata.

const memoria = new Map<string, string>();

const ehFaltaDeEspaco = (erro: unknown) =>
  erro instanceof DOMException &&
  (erro.name === "QuotaExceededError" || erro.name === "NS_ERROR_DOM_QUOTA_REACHED");

export const lerItem = (chave: string): string | null => {
  try {
    return localStorage.getItem(chave);
  } catch {
    return memoria.get(chave) ?? null;
  }
};

export const gravarItem = (chave: string, valor: string) => {
  try {
    localStorage.setItem(chave, valor);
  } catch (erro) {
    if (ehFaltaDeEspaco(erro)) throw erro;
    memoria.set(chave, valor);
  }
};
